import React, {ReactNode} from 'react';

// styles
import {
  CustomDialogActions,
  CustomDialogContent,
  CustomModalContainer,
  CustomModalDialog,
  ModalDialogTitle,
} from './CustomModal-styles';
import {TitleLarge} from '../../styles';

type Props = {
  children: ReactNode;
  actionButtons: ReactNode;
  isOpen: boolean;
  title: string;
};

const CustomModal = ({children, actionButtons, isOpen, title}: Props) => {
  return (
    <CustomModalContainer open={isOpen} hideBackdrop={true}>
      <CustomModalDialog variant="outlined">
        <ModalDialogTitle>
          <TitleLarge>{title}</TitleLarge>
        </ModalDialogTitle>
        <CustomDialogContent>{children}</CustomDialogContent>
        <CustomDialogActions>{actionButtons}</CustomDialogActions>
      </CustomModalDialog>
    </CustomModalContainer>
  );
};

export default CustomModal;
